import Button from '@mui/material/Button';
import React, { useEffect, useState, useContext } from "react";
import getAllTests from "../../apis/Tests/getAllTests";
import "./AllTests.css";
import TestModal from "../../components/addTestModal/TestModal";
import EditTestModal from "../../components/editTestModal/EditTestModal";
import getTestTypes from "../../apis/Tests/getTestTypes";
import getSubskills from "../../apis/Tests/getSubskills";
import getAllRecruitmentPartnersAndClients from "../../apis/getAllRecruitmentPartnersAndClients";
import getSkillResponse from "../../apis/skills/getActiveSkills";
import questionBySubSkill from "../../apis/Tests/questionBySubskill";
import { UserTypeContext } from "../../AppRoute";
import DataTable from '../../components/DataTable/DataTable';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess.js';

const stylesSx = {
  fontRoboto: {
    fontFamily: 'Roboto, sans-serif',
  },
  button: {
    marginBottom: '10px', // or use mb: 1.25 for theme.spacing(1.25)
  },
};

const AllTests = ({ idContextTest }) => {
  const history = useNavigate();
  const [testData, setTestData] = useState({});
  const [testTypes, setTestTypes] = useState([]);
  const [skills, setSkills] = useState([]);
  const [subskills, setSubskills] = useState([]);
  const [AllActiveRecruitmentpartner, setAllActiveRecruitmentpartner] = useState([]);
  const allCustomers = [];
  const [allTestData, setAllTestData] = useState([]);
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const [questionBySkill, setQuestionBySkill] = useState([]);
  const [totalQuestion, setTotalQuestion] = useState(0);
  const { userType } = useContext(UserTypeContext)
  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]
  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    const activityOptions = [
      { label: 'All', value: '' },
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  const btnBlue = {
    color: '#fff',
    border: 'none',
    padding: '7px 23px 7px 23px',
    float: 'right',
    marginTop: '25px',
    marginBottom: '1em'
  };


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await getAllTest();
        await allTestTypes();
        await allSkills();
        await allSubskills();
        await allRecruitmentpartner();
      } catch (error) {
        setisDataLoaded(true);
      } finally {
        setisDataLoaded(true);
      }
    }
    fetchAllData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      let data = testData;
      let arr = [];
      let total = 0;
      for (let i = 0; i < data.testsubskillsmappings.length; i++) {
        if (data.testsubskillsmappings[i].noOfQuestion) {
          total += data.testsubskillsmappings[i].noOfQuestion;
        }
        if (data.testsubskillsmappings[i].subskillId) {
          const payload = {
            subSkillsId: data.testsubskillsmappings[i].subskillId ? data.testsubskillsmappings[i].subskillId : "",
          };
          const res = await questionBySubSkill(payload);
          if (res.status === 200) {
            arr.push(res.data.data.length);
          }
        }
      }
      setTotalQuestion(total);
      setQuestionBySkill(arr)
    }
    if (isEdit)
      getData();
  }, [isEdit])


  const getAllTest = async () => {
    const response = await getAllTests();
    setAllTestData(response.data.data);
    setisDataLoaded(true);

  };

  const allTestTypes = async () => {
    await getTestTypes()
      .then((response) => { setTestTypes(response.data.data) })
      .catch((error) => console.log(error));
  };

  const allSkills = async () => {
    await getSkillResponse()
      .then((response) => { setSkills(response) })
      .catch((error) => console.log(error));
  };

  const allSubskills = async () => {
    await getSubskills()
      .then((response) => { setSubskills(response.data.data) })
      .catch((error) => console.log(error));
  };

  const allRecruitmentpartner = async () => {
    await getAllRecruitmentPartnersAndClients()
      .then((response) => { setAllActiveRecruitmentpartner(response.data.data) })
      .catch((error) => console.log(error));
  }




  const editHandler = (props) => {
    if (Object.keys(props).length > 0) {
      let data = JSON.parse(JSON.stringify(props));
      setTestData(data);
      setIsEdit(true);
    } else {
      setTestData("");
    }
  };




  let columns = [
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => (
        <>
          <Button
            variant="contained"
            color="primary"
            className='edit-button-alltest-skill'
            onClick={() => editHandler(row.original)}
          >
            Edit
          </Button>
        </>
      ),
      size: 130,
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "testName",
      header: "Test Name",
      size: 300,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "testCode",
      header: "Test Code",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "testtype.name",
      header: "Test Type",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "recruitmentpartner.name",
      header: "Recruitment Organization",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "customer.name",
      header: "Customer",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "skill.name",
      header: "Skill",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 120,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
  ]

  const goToDashboard = () => {
    history("/admin-home");
  };

  return (
    <>
      {userType === "Admin" ?
        (
          <><TestModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            getTests={getAllTest}
            testTypes={testTypes}
            skills={skills}
            subskills={subskills}
            customers={allCustomers}
            recruitmentPartner={AllActiveRecruitmentpartner}
            setQuestionBySkill={setQuestionBySkill}
            questionBySkill={questionBySkill}
            totalQuestion={totalQuestion}
            setTotalQuestion={setTotalQuestion}
          />
            <EditTestModal
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              getTests={getAllTest}
              testData={testData}
              setTestData={setTestData}
              testTypes={testTypes}
              skills={skills}
              subskills={subskills}
              customers={allCustomers}
              recruitmentPartner={AllActiveRecruitmentpartner}
              setQuestionBySkill={setQuestionBySkill}
              questionBySkill={questionBySkill}
              totalQuestion={totalQuestion}
              setTotalQuestion={setTotalQuestion}
            />
            <div className='main_container_alltest'>
              <div className="table_container alltest_width">
                <div className="button_container">
                  <div className="communityHeader_manageUser ">
                    <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                      <Tooltip title="Go Back to Dashboard" placement="bottom">
                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                      </Tooltip>
                    </div>
                    <div className="communityTitle">Tests</div>
                  </div>
                  <Button
                    sx={stylesSx.button}
                    variant="contained"
                    style={btnBlue}
                    color="primary"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Add New Test
                  </Button>
                </div>
                <DataTable
                  data={allTestData}
                  columns={columns}
                  isLoading={!isDataLoaded}
                  initialColumnFilters={[
                    {
                      id: 'isActive',
                      value: 'true'
                    }
                  ]}
                />
              </div>
            </div>
          </>
        ) : (
          <UnauthorizedAccess />
        )}
    </>
  );
};

export default AllTests;

